/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ExportProductsCatalogMutationRequest,
  ExportProductsCatalogMutationResponse,
  ExportProductsCatalog400,
  ExportProductsCatalog500,
} from '../types/ExportProductsCatalog'

function getExportProductsCatalogUrl() {
  const res = {
    method: 'POST',
    url: `/api/v1/products/catalog/products/export/` as const,
  }
  return res
}

/**
 * @description Handle export request via POST.
 * @summary Export products catalog to CSV or XLSX
 * {@link /api/v1/products/catalog/products/export/}
 */
export async function exportProductsCatalog(
  data: ExportProductsCatalogMutationRequest,
  config: Partial<RequestConfig<ExportProductsCatalogMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ExportProductsCatalogMutationResponse,
    ResponseErrorConfig<ExportProductsCatalog400 | ExportProductsCatalog500>,
    ExportProductsCatalogMutationRequest
  >({
    method: 'POST',
    url: getExportProductsCatalogUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
